import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import { Message as Message$1 } from '@andes/message';
import classnames from 'classnames';
import { validateSnackbarColor, constants } from '@vpp-frontend-components/common';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
const namespace$1 = 'ui-pdp-message';
const namecolorspace = 'ui-pdp-background-color';

/**
 * Message component
 * @typedef {import('../../index').Message}
 */
const Message = _ref => {
  let {
    type = 'neutral',
    title = null,
    hierarchy = 'quiet',
    closeable = false,
    className = '',
    children,
    text = null,
    actionsPosition = 'bottom',
    actions = null,
    bgColor = null
  } = _ref;
  return /*#__PURE__*/_jsx(Message$1, {
    className: classnames(namespace$1, className, {
      [`${namecolorspace}--${bgColor}`]: bgColor,
      [`${namespace$1}--closeable`]: closeable
    }),
    color: validateSnackbarColor(type),
    hierarchy: hierarchy,
    closable: closeable,
    title: title,
    actionsPosition: actionsPosition,
    actions: actions
  }, void 0, text || children);
};
const namespace = 'ui-pdp-question-warning';

/**
 * QuestionWarningMessage component
 * @typedef {import('../../index').QuestionWarningMessage}
 */
const QuestionWarningMessage = _ref => {
  let {
    showVariationsError = () => {},
    customMessage = null
  } = _ref;
  const {
    devices
  } = constants;
  const {
    staticProps: {
      deviceType
    }
  } = useVppContext();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const {
    hierarchy,
    message_type,
    closeable,
    primary_action,
    body
  } = customMessage;
  const handleMessageClick = () => {
    if (deviceType === devices.DESKTOP) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      showVariationsError(deviceType, 'QADB');
    }
    if (deviceType === devices.MOBILE) {
      showVariationsError(deviceType, 'QADB');
    }
  };
  return /*#__PURE__*/_jsx(Message, {
    className: "mt-20",
    hierarchy: hierarchy,
    type: message_type,
    closeable: closeable
  }, void 0, /*#__PURE__*/_jsx(StyledLabel, {
    className: `${namespace}__text`,
    as: "p",
    text: body.text
  }), /*#__PURE__*/_jsx("button", {
    type: "button",
    className: `${namespace}__action`,
    "data-testid": "warning-action",
    onClick: handleMessageClick
  }, void 0, componentEnhance.jsx(primary_action.label.text)));
};
const mapJsonToProps = _ref => {
  var _body$text, _title$text;
  let {
    message_type,
    body,
    title,
    closeable,
    hierarchy,
    bg_color,
    className,
    state,
    primary_action
  } = _ref;
  return {
    type: message_type,
    text: (_body$text = body === null || body === void 0 ? void 0 : body.text) !== null && _body$text !== void 0 ? _body$text : '',
    title: (_title$text = title === null || title === void 0 ? void 0 : title.text) !== null && _title$text !== void 0 ? _title$text : '',
    hierarchy,
    closeable,
    bgColor: bg_color,
    className: `ui-vpp-message ${className || ''}`,
    state,
    primary_action
  };
};
export { Message, QuestionWarningMessage, mapJsonToProps };
